<app-loading-bar></app-loading-bar>

<app-quickview></app-quickview>

@if (showGeneralNavMenu && !isIframeMode) {
<app-general-navigation class="navigation-rail"></app-general-navigation>
}

@if (deviceDetector.isMobile() && !isIframeMode) {
<!-- mobilemenu -->
<app-mobile-menu-new [location]="location"></app-mobile-menu-new>
<!-- mobilemenu / end -->
}

<app-header-dropcart *ngIf="dropcartType === 'offcanvas' && !isIframeMode" type="offcanvas"></app-header-dropcart>

<!-- site -->
<div class="site" [class.iframe-mode]="isIframeMode">
    <!-- mobile site__header -->
    <!-- <header class="site__header d-lg-none">
        <app-mobile-header stickyMode="alwaysOnTop"></app-mobile-header>
    </header> -->
    <!-- mobile site__header / end -->

    <!-- desktop site__header -->
    <!-- <header *ngIf="headerLayout" class="site__header d-lg-block d-none">
        <app-header [layout]="headerLayout"></app-header>
    </header> -->
    <!-- desktop site__header / end -->

    <ng-container *ngIf="!isIframeMode">
        <header class="site__header pt-[90px]" [class]="location()!=='rfq' ? 'mobile:pt-[6rem]' : 'mobile:pt-[64px]'"
            [ngClass]="{'mobile_mode': deviceDetector.isMobile()}">
            <app-mobile-header-new [location]="location" *ngIf="deviceDetector.isMobile()"></app-mobile-header-new>
            <app-header-new *ngIf="!deviceDetector.isMobile()"></app-header-new>
        </header>
    </ng-container>

    <!-- site__body -->
    <div class="site__body" [class.iframe-body]="isIframeMode">
        <router-outlet></router-outlet>
    </div>
    <!-- site__body / end -->

    <!-- site__footer -->
    <footer class="site__footer" *ngIf="!deviceDetector.isMobile() && !isIframeMode">
        <app-footer></app-footer>
    </footer>
    <!-- site__footer / end -->

    <!-- <app-browsing-controls *ngIf="deviceDetector.isMobile()"></app-browsing-controls> -->
</div>
<!-- site / end -->